export default {
	nodata: {
		error:
			'Es ist ein Fehler aufgetreten, bitte versuchen Sie es zu einem späteren Zeitpunkt erneut',
		loading: 'Daten werden geladen',
		no_data: 'Keine Daten vorhanden',
		noDataLoaded: 'Es wurden keine {name} geladen',
	},
}
